/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { humanize } from "uno-js";
import { EDIT_OFFICER_ACCESS_STATUS } from "../pages/DisableUserDetails/graphql/editAccessControl.mutation";
import { REINVITE_USER} from "../pages/DisableUserDetails/graphql/reinviteUser.mutation";

import { toast } from "react-hot-toast";

const MODULE_NAME = "EditAccessStatusService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class EditAccessStatusService {
    private static instance: EditAccessStatusService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL;
    }
    public static getInstance(props: any = {}): EditAccessStatusService {
        if (!EditAccessStatusService.instance) {
            EditAccessStatusService.instance = new EditAccessStatusService(
                props
            );
        }
        return EditAccessStatusService.instance;
    }

    async reinviteUser(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `reinvite user data in service`, data);

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: REINVITE_USER,
                    variables: {email:data},
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "reinvite user status ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async editAccessStatus(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `Edit Access Status  data in service`, data);

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_OFFICER_ACCESS_STATUS,
                    variables: {
                        ...data,
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT Access Status: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
